<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <section>
    <!--工具条-->
    <el-row>
      <el-col :span="24" class="toolbar not-print" style="padding-bottom: 0px;">
        <el-form :inline="true" :model="filters">
          <el-col>
            <el-form-item label="客户名称:" v-if="me.rname === 'ROLE_PLATFORM' || me.rname === 'ROLE_ADMIN' || me.rname === 'ROLE_DEMO'">
              <el-select v-model="filters.companyId" filterable clearable placeholder="请选择" @change="companyChange"
                         style="width:180px;">
                <el-option
                  v-for="item in companies" :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域:">
              <el-select v-model="filters.groupId" clearable placeholder="请选择" @change="groupChange"
                         style="width:150px;">
                <el-option
                  v-for="item in groups" :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称:">
              <el-select v-model="filters.deviceId" clearable placeholder="请选择" style="width:180px;">
                <el-option
                  v-for="item in devices"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="日期:">
              <el-date-picker
                v-model="filters.date"
                type="date"
                :picker-options="pickerOptions0"
                placeholder="选择时间"
                align="right" style="width:130px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button :disabled="!filters.date || !(filters.companyId || filters.groupId) || !filters.deviceId"
                         type="primary" v-on:click="getDatas" size="small">查询
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <el-col :span="24">
      <div id="chart1" class="chart3"></div>
    </el-col>

    <el-col :span="24" style="margin-top: 50px;" v-if="visible">
      <el-table :data="fuheData" border highlight-current-row v-loading="listLoading"
                style="width: 100%;">
        <el-table-column header-align="center" prop="name" label="数据类型" align="center" width="180">
        </el-table-column>
        <el-table-column header-align="center" label="最大值" min-width="160">
          <el-table-column header-align="center" label="值" min-width="60" align="center">
            <template scope="scope">
              {{scope.row.max}} kVar
            </template>
          </el-table-column>
          <el-table-column header-align="center" prop="maxTime" label="发生时间" min-width="100" :formatter="formatMaxTime"
                           align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column header-align="center" label="最小值" min-width="160">
          <el-table-column header-align="center" label="值" min-width="60" align="center">
            <template scope="scope">
              {{scope.row.min}} kVar
            </template>
          </el-table-column>
          <el-table-column header-align="center" prop="minTime" label="发生时间" min-width="100" :formatter="formatMinTime"
                           align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-col>
  </section>
</template>
<style scoped>
  .chart3 {
    width: 100% !important;
    height: 300px !important;
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    box-sizing: border-box;
  }
</style>
<script>
  import echarts from 'echarts'
  //import NProgress from 'nprogress'
  import moment from 'moment';
  import {
    getCompanyList,
    getGroupList,
    getDevicesByGroupList,
    getDianliDataList,
    getEnergyLevelList
  } from '../../api/api';

  export default{
    data(){
      return {
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        filters: {
          companyId: '',
          groupId: '',
          deviceId: '',
          date: moment().format('YYYY-MM-DD'),
        },
        me: JSON.parse(sessionStorage.getItem('user')),
        companies: [],
        groups: [],
        devices: [],
        fuheData: [],
        listLoading: false,
        visible: false,
        chart1: {},
      }
    },
    methods: {
      formatMaxTime: function (row, column) {
        return moment(row.maxTime).utc().format('HH:mm');
      },
      formatMinTime: function (row, column) {
        return moment(row.minTime).utc().format('HH:mm');
      },
      companyChange: function (val) {
        this.filters.groupId = '';
        this.filters.deviceId = '';
        this.getGroups(val);
      },
      groupChange: function (val) {
        this.filters.deviceId = '';
        this.getDevicesByGroup(val);
      },
      //获取企业列表
      getCompanies() {
        let para = {
          name: ''
        };
        //NProgress.start();
        getCompanyList(para).then((res) => {
          this.companies = res.data.list;
          if (!this.filters.companyId)
            this.filters.companyId = this.companies[0].id;
          //NProgress.done();
        });
      },
      //获取企业列表
      getGroups(company) {
        let para = {
          companyId: company
        };
        //NProgress.start();
        getGroupList(para).then((res) => {
          this.groups = res.data.list;
          this.filters.groupId = this.groups[0].id;
          if (this.groups.length == 0) {
            if (this.filters.companyId)
              this.getDevicesByGroup('');
          } else {
            this.getDevicesByGroup(this.groups[0].id);
          }
          //NProgress.done();
        });
      },
      getDevicesByGroup(val) {
        let para = {
          groupId: val
        };
        //NProgress.start();
        getDevicesByGroupList(para).then((res) => {
          this.devices = res.data.filter(t => !t.deviceId.toUpperCase().startsWith("9"));
          this.filters.deviceId = this.devices[0].id;

          this.getDatas();
          //NProgress.done();
        });
      },
      getDatas() {
        this.listLoading = true;
        this.visible = true;
        this.chart1 = echarts.init(document.getElementById('chart1'));
//        this.chart1.showLoading();
        let para = {
          companyId: this.filters.companyId,
          groupId: this.filters.groupId,
          deviceId: this.filters.deviceId,
          type: 6,
          date: moment.utc(this.filters.date).valueOf(),
        };

        getDianliDataList(para).then((res) => {

          if (res.data.length == 0) {
            this.listLoading = false;
            return;
          }

          var time = res.data.filter(t => t.type == 26).map(t => moment(t.createdAt).utc().format('HH:mm')).reverse();

          var a = res.data.filter(t => t.type == 26).map(t => t.value).reverse();
          var b = res.data.filter(t => t.type == 27).map(t => t.value).reverse();
          var c = res.data.filter(t => t.type == 28).map(t => t.value).reverse();
          var all = res.data.filter(t => t.type == 29).map(t => t.value).reverse();

          var lowestA = Number.POSITIVE_INFINITY;
          var highestA = Number.NEGATIVE_INFINITY;
          var tmp1;
          var dl1 = res.data.filter(t => t.type == 26);
          for (var i=dl1.length-1; i>=0; i--) {
            tmp1 = dl1[i].value;
            if (tmp1 < lowestA) lowestA = tmp1;
            if (tmp1 > highestA) highestA = tmp1;
          }

          var lowestB = Number.POSITIVE_INFINITY;
          var highestB = Number.NEGATIVE_INFINITY;
          var tmp2;
          var dl2 = res.data.filter(t => t.type == 27);
          for (var i=dl2.length-1; i>=0; i--) {
            tmp2 = dl2[i].value;
            if (tmp2 < lowestB) lowestB = tmp2;
            if (tmp2 > highestB) highestB = tmp2;
          }

          var lowestC = Number.POSITIVE_INFINITY;
          var highestC = Number.NEGATIVE_INFINITY;
          var tmp3;
          var dl3 = res.data.filter(t => t.type == 28);
          for (var i=dl3.length-1; i>=0; i--) {
            tmp3 = dl3[i].value;
            if (tmp3 < lowestC) lowestC = tmp3;
            if (tmp3 > highestC) highestC = tmp3;
          }

          var lowestAll = Number.POSITIVE_INFINITY;
          var highestAll = Number.NEGATIVE_INFINITY;
          var tmp4;
          var dl4 = res.data.filter(t => t.type == 29);
          for (var i=dl4.length-1; i>=0; i--) {
            tmp4 = dl4[i].value;
            if (tmp4 < lowestAll) lowestAll = tmp4;
            if (tmp4 > highestAll) highestAll = tmp4;
          }

          this.fuheData = [{
            name: 'A相无功功率',
            max: highestA,
            maxTime: dl1.filter(t => t.value == highestA)[0].createdAt,
            min: lowestA,
            minTime: dl1.filter(t => t.value == lowestA)[0].createdAt,
          },{
            name: 'B相无功功率',
            max: highestB,
            maxTime: dl2.filter(t => t.value == highestB)[0].createdAt,
            min: lowestB,
            minTime: dl2.filter(t => t.value == lowestB)[0].createdAt,
          },{
            name: 'C相无功功率',
            max: highestC,
            maxTime: dl3.filter(t => t.value == highestC)[0].createdAt,
            min: lowestC,
            minTime: dl3.filter(t => t.value == lowestC)[0].createdAt,
          },{
            name: '总无功功率',
            max: highestAll,
            maxTime: dl4.filter(t => t.value == highestAll)[0].createdAt,
            min: lowestAll,
            minTime: dl4.filter(t => t.value == lowestAll)[0].createdAt,
          }];

          this.listLoading = false;

          let para = {
            cityId: this.companies.filter(t => t.id == this.filters.companyId)[0].cityId,
          };

          function cal(target) {
            var h = parseInt(target.split(':')[0]);
            var m = parseInt(target.split(':')[1]);

            var goal = h * 60 + m;

            var closest = time.reduce(function (prev, curr) {
              var prevH = parseInt(prev.split(':')[0]);
              var prevM = parseInt(prev.split(':')[1]);
              var currH = parseInt(curr.split(':')[0]);
              var currM = parseInt(curr.split(':')[1]);
              var previ = prevH * 60 + prevM;
              var curri = currH * 60 + currM;
              return Math.abs(curri - goal) < Math.abs(previ - goal)? curr : prev;
            });

            return closest;
          }

          function filterLevelName(level) {
            switch(level) {
              case 1:
                return '尖峰';
              case 2:
                return '高峰';
              case 3:
                return '平段';
              case 4:
                return '低谷';
              default:
                return '';
            }
          }

          function filterLevelColor(level) {
            switch(level) {
              case 1:
                return '#DDA2A6';
              case 2:
                return '#A79FF0';
              case 3:
                return '#A8F2A6';
              case 4:
                return '#ABDCF0';
              default:
                return '';
            }
          }

          getEnergyLevelList(para).then((res) => {

            res.data.list.forEach(t => {
              if (cal(t.startTime)) {
                var tt = [{
                  name: filterLevelName(t.level),
                  xAxis: cal(t.startTime),
                  itemStyle: {
                    normal: {
                      color: filterLevelColor(t.level)
                    }
                  },
                  label: {
                    normal: {
                      textStyle: {
                        color: '#000000'
                      }
                    }
                  }
                }, {
                  xAxis: cal(t.endTime),
                  itemStyle: {
                    normal: {
                      color: filterLevelColor(t.level)
                    }
                  },
                  label: {
                    normal: {
                      textStyle: {
                        color: '#000000'
                      }
                    }
                  }
                }];
                if (tt[0].xAxis != tt[1].xAxis)
                  options.series[0].markArea.data.push(tt);
              }
//              this.chart1.hideLoading();
            });
            this.chart1.setOption(options);

          });

          var options = {
            title: {
              text: '无功功率',
              left: 'center',
              top: 0
            },
            grid: {
              top: 50,
              left: '5%',
              right: '5%',
              bottom: 50,
            },
            tooltip: {
              trigger: 'axis',
//              axisPointer: {
//                type: 'shadow',
//                label: {
//                  backgroundColor: '#283b56'
//                }
//              }
            },
            legend: {
              data: ['总无功功率', 'A相无功功率', 'B相无功功率', 'C相无功功率'],
              bottom: 0,
              selectedMode: false
            },
            dataZoom: {
              show: false,
              start: 0,
              end: 100
            },
            xAxis: [
              {
                type: 'category',
                boundaryGap: false,
                splitLine: {
                  show: true,
                },
//                data: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00',
//                  '05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00',
//                  '09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00',
//                  '13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00',
//                  '17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00',
//                  '21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45','24:00'
//                ]
                data: time

              }
            ],
            yAxis: [
              {
                type: 'value',
                scale: true,
                min: 0,
                axisLabel: {formatter: '{value} kVar'},
                name: '无功功率',
                boundaryGap: [0.2, 0.2]
              },
            ],
            series: [
              {
                name: '总无功功率',
                type: 'line',
                data: all,
                smooth: true,
//                              areaStyle: {
//                                normal: {
//                                  color: '#ff0000',
//                                  opacity: 1
//                                }
//                              },
                markArea: {
                  data: []
                },
              },
              {
                name: 'A相无功功率',
                type: 'line',
                smooth: true,
                data: a
              },
              {
                name: 'B相无功功率',
                type: 'line',
                smooth: true,
                data: b
              },
              {
                name: 'C相无功功率',
                type: 'line',
                smooth: true,
                data: c
              }
            ]
          };

          this.chart1.setOption(options);
          //NProgress.done();
        });
      },
    },
    mounted() {
      this.filters.companyId = (this.me.rname === 'ROLE_PLATFORM' || this.me.rname === 'ROLE_ADMIN') ? '' : this.me.companyId;
      this.getCompanies();
      this.getGroups(this.filters.companyId);
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// InActivePower.vue?6b740f4a